import React, { useState } from 'react';
import '../CommodityDetailModal.css';

export default function TransactionModal({ open, onClose, cargoItem, onConfirm, defaultRevenue = 0, defaultQty }) {
  const [totalRevenue, setTotalRevenue] = useState(defaultRevenue);
  const [qtySold, setQtySold] = useState(cargoItem?.qty || 0);

  React.useEffect(() => {
    if (open) {
      setTotalRevenue(Number(defaultRevenue) || 0);
      setQtySold(typeof defaultQty === 'number' ? defaultQty : (cargoItem?.qty || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, cargoItem, defaultRevenue, defaultQty]);

  // PRD-025: Calculate price per SCU when user enters total proceeds
  const pricePerSCU = React.useMemo(() => {
    const qty = Number(qtySold) || 0;
    const scu = Number(cargoItem?.scu) || 0;
    const revenue = Number(totalRevenue) || 0;

    if (qty <= 0 || scu <= 0 || revenue <= 0) return 0;

    return revenue / (qty * scu);
  }, [qtySold, cargoItem?.scu, totalRevenue]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>&times;</button>
        <h2>Sell Cargo — {cargoItem?.name}</h2>

        <div className="modal-body">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: 'end' }}>
            <div>
              <label className="block mb-2 text-sm" style={{ color: '#a0aec0' }}>Quantity Sold</label>
              <input
                type="number"
                className="location-select-dropdown"
                value={qtySold}
                max={cargoItem?.qty || 0}
                onChange={(e) => setQtySold(parseInt(e.target.value || '0', 10))}
              />
            </div>
            <div>
              <label className="block mb-2 text-sm" style={{ color: '#a0aec0' }}>
                Total Proceeds (aUEC)
                <span style={{ color: '#fbbf24', fontSize: '0.85em', marginLeft: '8px' }}>
                  * Required for price tracking
                </span>
              </label>
              <input
                type="number"
                className="location-select-dropdown"
                value={totalRevenue}
                onChange={(e) => setTotalRevenue(parseFloat(e.target.value || '0'))}
                placeholder="Enter actual sale amount"
                style={{ 
                  borderColor: totalRevenue > 0 ? '#10b981' : '#ef4444',
                  borderWidth: '2px'
                }}
              />
              {totalRevenue === 0 && (
                <div style={{ color: '#ef4444', fontSize: '0.8em', marginTop: '4px' }}>
                  ⚠️ Please enter the actual amount you received
                </div>
              )}
              {/* PRD-025: Display calculated price per SCU */}
              {pricePerSCU > 0 && (
                <div style={{ color: '#10b981', fontSize: '0.85em', marginTop: '6px', fontWeight: 'bold' }}>
                  💰 {pricePerSCU.toFixed(2)} aUEC per SCU
                </div>
              )}
            </div>
          </div>

          {/* PRD-025: Summary of calculation */}
          {pricePerSCU > 0 && (
            <div style={{
              marginTop: '15px',
              padding: '12px',
              background: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.3)',
              borderRadius: '8px',
              fontSize: '0.9em',
              color: '#10b981'
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>📊 Price Breakdown:</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px', color: '#94a3b8' }}>
                <span>Total SCU:</span>
                <span style={{ textAlign: 'right', fontWeight: 'bold' }}>{qtySold} × {cargoItem?.scu} = {qtySold * (cargoItem?.scu || 0)} SCU</span>
                <span>Price per SCU:</span>
                <span style={{ textAlign: 'right', fontWeight: 'bold', color: '#10b981' }}>{pricePerSCU.toFixed(2)} aUEC</span>
              </div>
              <div style={{ marginTop: '8px', fontSize: '0.85em', opacity: 0.8 }}>
                This price data will be submitted to community charts
              </div>
            </div>
          )}
          <div className="modal-actions">
            <button onClick={onClose} className="button-secondary">Cancel</button>
            <button
              className="button-primary"
              onClick={() => {
                if (totalRevenue > 0) {
                  onConfirm && onConfirm({ qtySold, totalRevenue });
                  onClose && onClose();
                }
              }}
              disabled={totalRevenue <= 0}
              style={{
                opacity: totalRevenue <= 0 ? 0.5 : 1,
                cursor: totalRevenue <= 0 ? 'not-allowed' : 'pointer'
              }}
              title={totalRevenue <= 0 ? 'Please enter the actual sale amount' : ''}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
